<!-- src/views/DashboardView.vue -->

<template>
  <!--begin::Content wrapper-->
  <div class="d-flex flex-column flex-column-fluid">
    <!--begin::Toolbar-->
    <div id="kt_app_toolbar" class="app-toolbar py-3 py-lg-6">
      <!--begin::Toolbar container-->
      <div id="kt_app_toolbar_container" class="app-container container-fluid d-flex flex-stack">
        <!--begin::Page title-->
        <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
          <!--begin::Title-->
          <h1 class="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
            منصة أكاديميا Academia
          </h1>
          <!--end::Title-->
          <!--begin::Breadcrumb-->
          <ul class="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0 pt-1">
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">
              <a href="../../demo1/dist/index.html" class="text-muted text-hover-primary">الصفحة الرئيسية</a>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item">
              <span class="bullet bg-gray-400 w-5px h-2px"></span>
            </li>
            <!--end::Item-->
            <!--begin::Item-->
            <li class="breadcrumb-item text-muted">المحفظة</li>
            <!--end::Item-->
          </ul>
          <!--end::Breadcrumb-->
        </div>
        <!--end::Page title-->
        <!--begin::Actions-->
        <div class="d-flex align-items-center gap-2 gap-lg-3">
          <!--begin::Secondary button-->
          <!--<a
              href="#"
              class="btn btn-sm fw-bold bg-body btn-color-gray-700 btn-active-color-primary"
              data-bs-bs-toggle="modal"
              data-bs-bs-target="#kt_modal_create_app"
              >Rollover</a
            >-->
          <!--end::Secondary button-->
          <!--begin::Primary button-->
          <!-- <a
              href="#"
              class="btn btn-sm fw-bold btn-light-success"
              data-bs-bs-toggle="modal"
              data-bs-bs-target="#kt_modal_new_target"
              >Add Target</a
            >-->
          <!--end::Primary button-->
        </div>
        <!--end::Actions-->
      </div>
      <!--end::Toolbar container-->
    </div>
    <!--end::Toolbar-->
    <!--begin::Content-->
    <div id="kt_app_content" class="app-content flex-column-fluid">
      <!--begin::Content container-->
      <div id="kt_app_content_container" class="app-container container-fluid">
        <!--begin::Row-->

        <div v-if="isLoading == true"
          style="font-weight: 800;border-radius: 10px;padding: 50px;font-size: large;text-align: center;background: #73737326;"
          class="loader text-success">
          جاري التحميل
          <div class="spinner-border text-success" role="status">
            <span class="sr-only"></span>
          </div>
        </div>
        <div v-if="isLoggedIn == false && isLoading == false" class="col-12">
          <div class="card text-center p-5 not-login">
            <span class="icon"><i class="bi bi-person-badge"></i></span>
            <h3 class="mb-4">يرجى تسجيل الدخول للإستمرار </h3>
            <span>
              <a href="login" class="btn btn-success">
                تسجيل الدخول <i class="fa fa-sign-in"></i>
              </a>
            </span>
          </div>
        </div>

        <div v-if="isLoggedIn == true" class="row g-5 g-xl-10 mb-5 mb-xl-10">
          <div class="col-xl-2"></div>
          <div class="col-xl-8">
            <!--begin::List Widget 8-->
            <div class="card mb-5 mb-xl-8">
              <!--begin::Header-->
              <div class="card-header align-items-center border-0 mt-4">
                <h3 class="card-title align-items-start flex-column">
                  <span class="fw-bold text-dark">المحفظة</span>
                  <span class="text-muted mt-1 fw-semibold fs-7">الرصيد والعمليات</span>
                </h3>
              </div>
              <!--end::Header-->
              <!--begin::Body-->
              <div class="card-body pt-3">
                <!--begin::Item-->
                <div class="d-flex align-items-sm-center mb-7">
                  <!--begin::Symbol-->
                  <div class="symbol symbol-60px symbol-2by3 me-4">
                    <div class="symbol-label" :style="{
                      backgroundImage: `url(${require('@/assets/wallet.png')})`,
                      backgroundColor: `#ddd`,
                      width: `77px`
                    }"></div>
                  </div>
                  <!--end::Symbol-->
                  <!--begin::Content-->
                  <div class="d-flex flex-row-fluid align-items-center flex-wrap my-lg-0 me-2">
                    <!--begin::Title-->
                    <div class="flex-grow-1 my-lg-0 my-2 me-2">
                      <a href="#" class="text-gray-800 fw-bold text-hover-primary fs-1" id="wallet-balance">{{
                        walletBalance }}</a>
                      <span class="text-muted fw-semibold d-block pt-1">رصيد محفظتك</span>
                    </div>
                    <!--end::Title-->
                    <!--begin::Section-->
                    <div class="d-flex align-items-center">
                      <a class="btn btn-success border-0" @click="showModal('payments-modal')">
                        <span>إشحن محفظتك</span>
                      </a>
                    </div>
                    <!--end::Section-->
                  </div>
                  <!--end::Content-->
                </div>
              </div>
              <!--end::Body-->
            </div>
            <!--end::List Widget 8-->

            <div class="wallet-transaction">
              <div class="card">
                <div class="card-body">
                  <div class="load" style="text-align: center;">
                    <div class="spinner-border text-success" style="width: 3rem; height: 3rem;" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </div>
                  </div>

                  <div class="table-responsive">

                    <table class="table table-hover table-striped mb-0 text-center" id="transaction-balance">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>نوع العملية</th>
                          <th>وصف المعاملة</th>
                          <th>التاريخ</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody></tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- end main content-->
        </div>
      </div>
      <!--end::Content container-->
    </div>
    <!--end::Content-->
  </div>
  <!--end::Content wrapper-->
  <Payments />
  <Academia />
  <Online />
  <Icash />
  <StripeAcademia />

</template>

<script>
import {
  apiUrl,
  courseImagePath,
  deviceId,
  getBrowserName,
  api_get,
  api,
  instructorImagePath,
} from "@/utils/api"; // Adjust the import path according to your project structure
import Payments from "./Payments.vue";
import Academia from "./Academia.vue";
import Online from "./Online.vue";
import Icash from "./Icash.vue";
import StripeAcademia from "./Stripe.vue";

export default {
  name: "Wallet",
  components: {
    Payments,
    Academia,
    Online,
    Icash,
    StripeAcademia,
  },
  data() {
    return {
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
      isLoggedIn: false,
      isLoading: true,
      walletBalance: 0
    };
  },
  mounted() {
    this.getBalance();
  },
  created() {
    var walletBalanceDiv = $("#wallet-balance");
    var transactionBalanceDiv = $("#transaction-balance");
    setTimeout(() => {
      this.getTransactions(transactionBalanceDiv);
    }, 3500);
  },
  methods: {
    async getBalance() {
      try {
        const response = await fetch(`${apiUrl}/wallets/get-balance?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });
        this.isLoading = false;
        if (!response.redirected || !response.ok) {
          this.isLoggedIn = true;
          const data = await response.json();
          console.log("Balance data retrieved successfully:", data);
          this.walletBalance = parseFloat(data.wallet_balance).toFixed(2) + " د.ل";
        } else {
          this.isLoggedIn = false;
          console.error("Failed to retrieve balance");
        }
      } catch (error) {
        console.error("Error retrieving balance:", error);
      }
    },

    getTransactions(transactionBalanceDiv) {


      const self = this; // Store the Vue instance context in a variable

      $.ajax({
        url:
          apiUrl +
          "/wallets/get-transactions?secret=a463c0cd-78ed-4bda-a5f6-f70c3e597dfb",
        method: "GET",
        beforeSend: function (xhr) {
          xhr.setRequestHeader("Authorization", "Bearer " + self.token); // Use the stored context
          // Show the spinner loader
          $("#loader").addClass("spinner-border text-primary");
        },
        success: function (response) {

          // Update the transactions table content
          var transactions = response.transactions;
          console.log("Transactions data retrieved successfully:", response.transactions);

          // Clear the existing table data
          $("#transaction-balance tbody").empty();

          // Loop through each transaction and append a new row to the table
          $.each(transactions, function (index, transaction) {
            var row = "<tr>";
            row += "<td>" + (index + 1) + "</td>";

            // Determine the transaction type based on the 'credit' property
            var transactionType = transaction.credit
              ? "شحن محفظة"
              : "عملية دفع";
            row += "<td>" + transactionType + "</td>";

            // Escape the 'details' text to prevent any potential XSS vulnerabilities
            var details = $("<div>").text(transaction.details).html();
            row += "<td>" + details + "</td>";

            // Format the date using Moment.js library
            var formattedDate = transaction.created_at;
            row += "<td>" + formattedDate + "</td>";

            // Add the arrow icon based on the transaction type
            var arrowIcon = transaction.credit
              ? "fa-arrow-down"
              : "fa-arrow-up";
            var arrowColor = transaction.credit ? "#00d12b" : "#ff4141";

            row +=
              '<td><span style="border-radius: 15px;padding: 3px 15px;background-color: #e4e4e45e;font-size: 25px;">' +
              '<i style="font-size:25px;color:' +
              arrowColor +
              ';" class="fa-solid ' +
              arrowIcon +
              '"></i></span></td>';

            row += "</tr>";

            // Append the row to the table body
            $("#transaction-balance tbody").append(row);
          });
          $('.load').remove();
        },
        error: function (xhr, status, error) {
          console.error("Error retrieving transactions:", error);
          // Hide the spinner loader
          $("#loader").removeClass("spinner-border text-primary");
        },
      });
    },
    logout() {
      api(
        "/logout",
        "POST",
        {},
        { Authorization: `Bearer ${this.token}` },
        false
      ).then(async (response) => {
        let res = await response.json();
        localStorage.removeItem("access_token");
        window.location.href = "/login";
      });
      localStorage.removeItem("access_token");
    },
    showModal(modal) {
      var myModal = new bootstrap.Modal(document.getElementById(modal));
      myModal.show();
    },
  },
};
</script>